import { isEmpty } from 'lodash'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { PrivacyPolicy } from 'pages/privacy-policy'
import { makeTraceDetails } from 'common'

import { TPrivacyPolicyLinkHookReturn } from '../types/usePrivacyPolicyLink.types'

const componentName = PrivacyPolicy.name

export const usePrivacyPolicyLink = (): TPrivacyPolicyLinkHookReturn => {
  const { privacyCenterContent, isAppLoading: isLoading, isAppError } = useAppContext()

  if (isLoading)
    return {
      content: {
        confirmButton: '',
        details: '',
        title: '',
      },
      traceDetails: '',
      componentName,
      isLoading,
      isError: false,
    }

  const content = privacyCenterContent?.components?.privacyPolicyLink?.content

  const isError = isAppError || isEmpty(content)

  const isActive = !!privacyCenterContent?.components?.privacyPolicyLink?.isActive

  if (isError || !isActive) {
    const traceDetails = makeTraceDetails(isActive, content)

    return {
      content: content ?? {
        confirmButton: '',
        details: '',
        title: '',
      },
      traceDetails,
      componentName,
      isError,
      isLoading,
    }
  }

  return {
    content,
    traceDetails: '',
    componentName,
    isLoading,
    isError,
  }
}
